import { render, staticRenderFns } from "./IconFile.vue?vue&type=template&id=3b003dc2&"
import script from "./IconFile.vue?vue&type=script&lang=js&"
export * from "./IconFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b003dc2')) {
      api.createRecord('3b003dc2', component.options)
    } else {
      api.reload('3b003dc2', component.options)
    }
    module.hot.accept("./IconFile.vue?vue&type=template&id=3b003dc2&", function () {
      api.rerender('3b003dc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconFile.vue"
export default component.exports